module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-4-blocks-88f64560ad19b47b7a3e61debcba6933.svg";